import { Component } from "@angular/core";
import { LicenseService } from "../../services/LicenseService";
import { ActivatedRoute, Router } from "@angular/router";
import { Console } from "console";

@Component({
    styles:[require('./license-sidenav.component.css')],
    template:require('./license-sidenav.component.html'),
    selector:'license-nav-bar'

})
export class LicenseSideNavComponent{
    licenseProductFilter:any = {ProductName:''};
    licenseProductList;
    selectedTitle;
    selectedProductId;
    constructor(
        private licenseService:LicenseService,
        private router:Router,
        private route:ActivatedRoute
    ){
        
    }
    ngOnInit(){
        this.licenseService.getLicensePortalProducts().subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.licenseProductList=data.DataObject
            }
        })
    }
    checkSelected(product){
        
        if(this.route.firstChild != null){
            this.route.firstChild.paramMap.subscribe((params)=>{
                this.selectedProductId=params.get('productId');
            })
            return product.ProductId==this.selectedProductId;
        }
    }
    getStyle(productName:string){
        this.selectedTitle=productName;
    }


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/license-sidenav/license-sidenav.component.ts